(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('yqn-premium-header')) {
    class YQNPremiumHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.section-header');
        this.header = this.querySelector('.yqn-header');
        this.desktopNav = this.querySelector('[data-yqn-desktop-nav]');
        this.stickyType = this.dataset.stickyType || 'none';
        this.scrollThreshold = Number(this.dataset.scrollThreshold || 12);
        this.lastScrollY = window.scrollY;
        this.scrollTicking = false;

        this.onScroll = this.requestScrollUpdate.bind(this);
        this.onResize = this.updateLayout.bind(this);
        this.onDesktopMenuPointerOver = this.handleDesktopMenuPointerOver.bind(this);
        this.onDesktopMenuPointerOut = this.handleDesktopMenuPointerOut.bind(this);
        this.onDesktopMenuKeydown = this.handleDesktopMenuKeydown.bind(this);

        if (this.stickyType === 'always' || this.stickyType === 'reduce-logo-size') {
          this.section.classList.add('shopify-section-header-sticky');
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });

        if (this.desktopNav) {
          this.desktopNav.addEventListener('pointerover', this.onDesktopMenuPointerOver);
          this.desktopNav.addEventListener('pointerout', this.onDesktopMenuPointerOut);
          this.desktopNav.addEventListener('keydown', this.onDesktopMenuKeydown);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateLayout());
          this.resizeObserver.observe(this.header);
        }

        this.updateLayout();
        this.updateScrollState();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
        this.desktopNav?.removeEventListener('pointerover', this.onDesktopMenuPointerOver);
        this.desktopNav?.removeEventListener('pointerout', this.onDesktopMenuPointerOut);
        this.desktopNav?.removeEventListener('keydown', this.onDesktopMenuKeydown);
        window.clearTimeout(this.desktopMenuCloseTimer);
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      get desktopHoverEnabled() {
        return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
      }

      handleDesktopMenuPointerOver(event) {
        if (!this.desktopHoverEnabled) return;

        const details = event.target.closest('details');
        if (!details || !this.desktopNav.contains(details) || details.contains(event.relatedTarget)) return;

        window.clearTimeout(this.desktopMenuCloseTimer);

        const topLevelMenu = details.parentElement?.tagName === 'HEADER-MENU';
        if (topLevelMenu) {
          this.desktopNav.querySelectorAll('header-menu > details[open]').forEach((openDetails) => {
            if (openDetails !== details) this.setMenuState(openDetails, false);
          });
        }

        this.setMenuState(details, true);
      }

      handleDesktopMenuPointerOut(event) {
        if (!this.desktopHoverEnabled) return;

        const details = event.target.closest('details');
        if (!details || !this.desktopNav.contains(details) || details.contains(event.relatedTarget)) return;

        window.clearTimeout(this.desktopMenuCloseTimer);
        this.desktopMenuCloseTimer = window.setTimeout(() => {
          if (!details.matches(':hover') && !details.contains(document.activeElement)) {
            this.setMenuState(details, false);
          }
        }, 140);
      }

      handleDesktopMenuKeydown(event) {
        if (event.key !== 'Escape') return;

        const details = event.target.closest('details[open]');
        if (!details || !this.desktopNav.contains(details)) return;

        event.preventDefault();
        this.setMenuState(details, false);
        details.querySelector(':scope > summary')?.focus();
      }

      setMenuState(details, open) {
        const summary = details.querySelector(':scope > summary');
        details.open = open;
        summary?.setAttribute('aria-expanded', String(open));
      }

      requestScrollUpdate() {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
          this.updateScrollState();
          this.scrollTicking = false;
        });
      }

      updateScrollState() {
        const currentScrollY = Math.max(window.scrollY, 0);
        const isPastThreshold = this.stickyType !== 'none' && currentScrollY > this.scrollThreshold;
        const isScrollingDown = currentScrollY > this.lastScrollY + 2;
        const isScrollingUp = currentScrollY < this.lastScrollY - 2;

        this.classList.toggle('is-scrolled', isPastThreshold);

        if (this.stickyType === 'on-scroll-up') {
          if (!isPastThreshold) {
            this.section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden');
          } else {
            this.section.classList.add('shopify-section-header-sticky');
            if (isScrollingDown) {
              this.section.classList.add('shopify-section-header-hidden');
              this.closeOpenMenus();
            } else if (isScrollingUp) {
              this.section.classList.remove('shopify-section-header-hidden');
            }
          }
        }

        this.lastScrollY = currentScrollY;
      }

      updateLayout() {
        if (!this.header || !this.section) return;

        document.documentElement.style.setProperty('--header-height', `${this.section.offsetHeight}px`);

        if (!this.desktopNav || this.classList.contains('is-drawer') || window.innerWidth < 990) {
          this.classList.remove('is-menu-collapsed');
          this.closeOpenMenus();
          return;
        }

        const menu = this.desktopNav.querySelector('.list-menu--inline');
        const brand = this.querySelector('.yqn-header__brand');
        if (!menu || !brand) return;

        const styles = window.getComputedStyle(this.header);
        const columnGap = Number.parseFloat(styles.columnGap) || 0;
        const availableWidth = Math.max(
          0,
          (this.header.getBoundingClientRect().width - brand.getBoundingClientRect().width - columnGap * 2) / 2
        );

        if (!this.classList.contains('is-menu-collapsed')) {
          const menuItems = Array.from(menu.children);
          const menuGap = Number.parseFloat(window.getComputedStyle(menu).columnGap) || 0;
          this.menuRequiredWidth = menuItems.reduce(
            (total, item) => total + item.getBoundingClientRect().width,
            menuGap * Math.max(0, menuItems.length - 1)
          );
        }

        const requiredWidth = this.menuRequiredWidth || 0;
        this.classList.toggle('is-menu-collapsed', requiredWidth > availableWidth + 2);
      }

      closeOpenMenus() {
        this.querySelectorAll('header-menu details[open]').forEach((details) => this.setMenuState(details, false));
        const searchModal = this.querySelector('details-modal');
        if (searchModal && typeof searchModal.close === 'function') searchModal.close(false);
      }
    }

    customElements.define('yqn-premium-header', YQNPremiumHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
